import axios from 'axios';
import { CLIENT } from "./constants";

const apiClient = axios.create({ baseURL: CLIENT.baseUrl });

const fetchDecorationTypes = () => apiClient.get('v1/decorations/types');

const fetchDecorationPortraits = () => apiClient.get('v1/decorations/portraits');

const fetchDecorations = (typeCode, page) => apiClient.get(`v1/decorations/search?typeCode=${typeCode}&page=${page}`);

const fetchBookingData = () => apiClient.get('v1/booking/data')

const fetchBookingDetail = (bookingId) => apiClient.get(`v1/booking/detail/${encodeURIComponent(bookingId)}`)

const postDecoration = (formBody) => apiClient.post(`v1/decoration/post`, formBody)

const postBooking = (formBody) => apiClient.post(`v1/booking/post`, formBody)

const updateBooking = (bookingId, fields) => apiClient.patch(`v1/booking/update/${encodeURIComponent(bookingId)}`, fields)

const fetchBookingList = () => apiClient.get('v1/boking/list');

const doLogin = (credentials) => apiClient.get(`v1/login?user=${credentials.user}&password=${credentials.password}`);

export {
    fetchDecorationTypes,
    fetchDecorationPortraits,
    fetchDecorations,
    fetchBookingData,
    fetchBookingDetail,
    postDecoration,
    postBooking,
    updateBooking,
    fetchBookingList,
    doLogin,
}